
	function mapRange(n, inMax, outMax) {
		return n * outMax / inMax;
	}


	function resample(inSamples, numOutSamples) {
		const outSamples = [];
		const ratio = inSamples.length / numOutSamples;
		for (let i = 0; i < numOutSamples; i++) {
			const from = Math.floor(i * ratio);
			const to = Math.floor((i + 1) * ratio);
			outSamples[i] = Math.max(...inSamples.slice(from, to));
		}
		return outSamples;
	}


	function getWaveData(element) {
		if (element.dataset.wave) {
			return resample(element.dataset.wave.split(',').map(Number), Math.floor(element.clientWidth))
				.map(x => x / 256);
		} else {
			return [];
		}
	}


	function buildWave(element) {
		let elWidth = element.clientWidth;

		let data = getWaveData(element);

		// cleanup elements from previous render
		while (element.firstChild) {
			element.removeChild(element.firstChild);
		}

		// let shadow = element.attachShadow({mode: 'open'});

		let container = document.createElement('div');
		container.classList.add('wave-container');
		container.style.width = elWidth + 'px';
		element.appendChild(container);

		let counter = 0;
		data.forEach((value) => {
			let block = document.createElement('i');
			block.style.height = (value * 100) + '%';
			container.appendChild(block);
			counter++;
		});

		let progressContainer = document.createElement('div');
		progressContainer.classList.add('progress-container');
		element.appendChild(progressContainer);

		let containerClone = container.cloneNode(true);
		progressContainer.appendChild(containerClone);

		let line = document.createElement('div');
		line.classList.add('center-line');
		element.appendChild(line);

		function handlePlay(e) {
			const progress = e.detail * 100;
			progressContainer.style.width = progress + "%";
		}

		element.removeEventListener('play', handlePlay);
		element.addEventListener('play', handlePlay);

		element.dataset.width = elWidth;
	}


	document.querySelectorAll('[audiowave]').forEach((waveElement) => {
		waveElement.addEventListener('build', e => {
			buildWave(waveElement);
		});

		window.addEventListener('resize', () => {
			if (waveElement.clientWidth !== Number(waveElement.dataset.width)) {
				buildWave(waveElement);
			} else {
			}
		})


		// test anim
		// var tl = gsap.timeline({repeat: -1, repeatDelay: 1});
		// tl.to(".progress-container", {width: '90%', duration: 1});
		// tl.to(".progress-container", {width: '20%', duration: 1});

	});


